"use strict";
exports.__esModule = true;
exports.Publication = void 0;
var Publication;
(function (Publication) {
    Publication["ActivityReport"] = "activity-report";
    Publication["SocialReport"] = "social-report";
    Publication["ThemeMemento"] = "theme-memento";
    Publication["StudyBarometre"] = "study-barometre";
    Publication["WhitePaper"] = "white-paper";
    Publication["PosteoBook"] = "posteo-book";
    Publication["PosteoMagazine"] = "posteo-magazine";
})(Publication = exports.Publication || (exports.Publication = {}));
//# sourceMappingURL=publication.js.map